<template>
  <v-dialog
    :value="value"
    max-width="500"
    persistent
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title>
        タグ一括対象化
      </v-card-title>

      <v-card-text>
        <p class="mb-4">
          選択したタグに紐づくすべてのアイテムを在庫管理の対象にします。
        </p>

        <v-form ref="form">
          <v-select
            :value="form.tagId"
            :items="tags"
            item-text="name"
            item-value="id"
            label="商品タグ *"
            :rules="[rules.required]"
            outlined
            dense
            class="mb-4"
            @input="onTagChange"
          />

          <v-text-field
            v-model.number="form.currentQuantity"
            label="現在在庫 *"
            type="number"
            step="1"
            min="0"
            :rules="[rules.required, rules.nonNegativeInteger]"
            outlined
            dense
            suffix="個"
            hint="一括設定する現在の在庫数量"
            persistent-hint
          />
        </v-form>

        <v-alert
          v-if="selectedTagName"
          type="info"
          dense
          text
          class="mt-4"
        >
          「{{ selectedTagName }}」タグのアイテムを対象にします。<br>
          ※ 既に対象のアイテムはスキップされます。
        </v-alert>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="close"
        >
          キャンセル
        </v-btn>
        <v-btn
          color="primary"
          :loading="isSaving"
          @click="save"
        >
          対象化
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  ref,
  reactive,
  computed,
  watch,
  getCurrentInstance,
} from '@vue/composition-api'
import VendibleTagApi from '@/api/v2/inventory/VendibleTag'

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    tags: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const vm = getCurrentInstance().proxy

    const form = reactive({
      tagId: null,
      currentQuantity: 0,
    })

    const isSaving = ref(false)

    // 選択中のタグ名
    const selectedTagName = computed(() => {
      if (!form.tagId) return null
      const tag = props.tags.find(t => String(t.id) === String(form.tagId))

      return tag ? tag.name : null
    })

    // タグ選択時の処理
    const onTagChange = value => {
      form.tagId = value
    }

    // バリデーションルール
    const rules = {
      required: v => (v !== null && v !== '' && v !== undefined) || '必須項目です',
      nonNegativeInteger: v => {
        if (v === null || v === '') return true
        const num = Number(v)

        return (Number.isInteger(num) && num >= 0) || '0以上の整数を入力してください'
      },
    }

    // ダイアログ開閉時のフォームリセット
    watch(() => props.value, newVal => {
      if (newVal) {
        form.tagId = null
        form.currentQuantity = 0
      }
    })

    const close = () => {
      emit('input', false)
    }

    const save = async () => {
      if (!vm.$refs.form.validate()) return

      isSaving.value = true

      try {
        await VendibleTagApi.tracking(form.tagId, {
          current_quantity: form.currentQuantity,
        })

        vm.$toast.success('対象化しました')
        emit('saved')
        close()
      } catch (error) {
        const message = error?.response?.data?.message || '対象化に失敗しました'
        vm.$toast.error(message)
      } finally {
        isSaving.value = false
      }
    }

    return {
      form,
      isSaving,
      selectedTagName,
      rules,
      onTagChange,
      close,
      save,
    }
  },
}
</script>
